import { render, staticRenderFns } from "./UserLocationsModal.vue?vue&type=template&id=6c15fe73&"
import script from "./UserLocationsModal.vue?vue&type=script&lang=js&"
export * from "./UserLocationsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports